export class AppSettings {
	static endpoints = {
		session: 'session',
	};
}
